import { useEffect, useState } from "react";
import moment from "moment";
import axios from "axios";
import { formatDisplayDates, timeToParam } from "../../utils/refund";
import { Api_Url } from "../../utils/ApiUrl";

const useCreditDashboardData = () => {
    const [show3, setShow3] = useState(false);
    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [activeKey, setActiveKey] = useState("0");
    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);

    const [stats, setStats] = useState(null);
    const [selectedTime, setSelectedTime] = useState("");
    const [showDateFilter, setShowDateFilter] = useState(false);
    const [dateFilterLabel, setDateFilterLabel] = useState("");

    const formatDates = (times) => {
        let date = null;
        let date1 = null;

        if (Array.isArray(times)) {
            // Custom date range from date picker
            let a = new Date(times[0]?.startDate);
            let b = new Date(times[0]?.endDate);
            date = moment(a).format("Y-MM-DDT00:00:00");
            date1 = moment(b).format("Y-MM-DDT23:59:59");
            setState(times);

            // Set date filter UI elements
            const startDateObj = date ? new Date(date) : null;
            const endDateObj = date1 ? new Date(date1) : null;
            setDateFilterLabel(formatDisplayDates(startDateObj, endDateObj));
            setStartDate(date);
            setEndDate(date1);
            setShowDateFilter(true);

            // Call API with the formatted dates
            fetchStats(date, date1);
        } else if (times === "1") {
            var date12 = new Date();
            var myDate = new Date();
            date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
            date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

            // Set date filter UI elements
            const startDateObj = date ? new Date(date) : null;
            const endDateObj = date1 ? new Date(date1) : null;
            setDateFilterLabel(formatDisplayDates(startDateObj, endDateObj));
            setStartDate(date);
            setEndDate(date1);
            setShowDateFilter(true);

            // Call API with the formatted dates
            fetchStats(date, date1);
        } else if (times === "3") {
            var date12 = new Date();
            var dateOffset = 24 * 60 * 60 * 1000 * 3; //3 days
            var myDate = new Date();
            myDate.setTime(myDate.getTime() - dateOffset);
            date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
            date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

            // Set date filter UI elements
            const startDateObj = date ? new Date(date) : null;
            const endDateObj = date1 ? new Date(date1) : null;
            setDateFilterLabel(formatDisplayDates(startDateObj, endDateObj));
            setStartDate(date);
            setEndDate(date1);
            setShowDateFilter(true);

            // Call API with the formatted dates
            fetchStats(date, date1);
        } else if (times === "seven") {
            var date12 = new Date();
            var dateOffset = 24 * 60 * 60 * 1000 * 7; //7 days
            var myDate = new Date();
            myDate.setTime(myDate.getTime() - dateOffset);
            date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
            date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

            // Set date filter UI elements
            const startDateObj = date ? new Date(date) : null;
            const endDateObj = date1 ? new Date(date1) : null;
            setDateFilterLabel(formatDisplayDates(startDateObj, endDateObj));
            setStartDate(date);
            setEndDate(date1);
            setShowDateFilter(true);

            // Call API with the formatted dates
            fetchStats(date, date1);
        } else if (times === "year") {
            var date12 = new Date();
            var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 year
            var myDate = new Date();
            myDate.setTime(myDate.getTime() - dateOffset);
            date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
            date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

            // Set date filter UI elements
            const startDateObj = date ? new Date(date) : null;
            const endDateObj = date1 ? new Date(date1) : null;
            setDateFilterLabel(formatDisplayDates(startDateObj, endDateObj));
            setStartDate(date);
            setEndDate(date1);
            setShowDateFilter(true);

            // Call API with the formatted dates
            fetchStats(date, date1);
        } else if (times === "month") {
            var date12 = new Date();
            var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
            var myDate = new Date();
            myDate.setTime(myDate.getTime() - dateOffset);
            date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
            date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");

            // Set date filter UI elements
            const startDateObj = date ? new Date(date) : null;
            const endDateObj = date1 ? new Date(date1) : null;
            setDateFilterLabel(formatDisplayDates(startDateObj, endDateObj));
            setStartDate(date);
            setEndDate(date1);
            setShowDateFilter(true);

            // Call API with the formatted dates
            fetchStats(date, date1);
        }
    };

    const fetchStats = async (start = null, end = null) => {
        try {
            const accessToken = localStorage.getItem('accessToken');
            let url = `${Api_Url}/credit/stats`;

            // Only add date parameters if both start and end are provided and not empty
            if (start && end) {
                url += `?startDate=${start}&endDate=${end}`;
            }

            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            setStats(response?.data?.data);
        } catch (error) {
            console.error('Error fetching credit stats:', error);
        }
    };

    const applyFilters = () => {
        // Only apply filters if both start and end dates are set
        if (startDate && endDate) {
            fetchStats(startDate, endDate);
            setShowDateFilter(true);
        } else {
            fetchStats();
            setShowDateFilter(false);
        }
        handleClose3();
    };

    const clearFilters = () => {
        setStartDate("");
        setEndDate("");
        setSelectedTime("");
        setShowDateFilter(false);
        setState([
            {
                startDate: new Date(),
                endDate: new Date(),
                key: "selection",
            },
        ]);
        setDateFilterLabel("");

        // Call API without date filters
        fetchStats();
    };

    const handleTimeSelect = (time) => {
        setSelectedTime(time);
        formatDates(timeToParam(time));
    };

    const removeDateFilter = () => {
        clearFilters();
    };

    const [tableKey, setTableKey] = useState(0);
    const refreshTable = () => {
        setTableKey(prevKey => prevKey + 1);
    };

    useEffect(() => {
       
        fetchStats();
    }, []);

    return {
        show3,
        handleClose3,
        handleShow3,
        startDate,
        endDate,
        activeKey,
        setActiveKey,
        state,
        setState,
        stats,
        selectedTime,
        showDateFilter,
        dateFilterLabel,
        formatDates,
        fetchStats,
        applyFilters,
        clearFilters,
        handleTimeSelect,
        removeDateFilter,
        tableKey,
        refreshTable,
    };
};

export default useCreditDashboardData;


// import { useEffect, useState } from "react";
// import moment from "moment";
// import axios from "axios";
// import { formatDisplayDates, timeToParam } from "../../utils/refund";
// import { Api_Url } from "../../utils/ApiUrl";

// const useCreditDashboardData = () => {
//     const [show3, setShow3] = useState(false);
//     const handleClose3 = () => setShow3(false);
//     const handleShow3 = () => setShow3(true);

//     const [startDate, setStartDate] = useState("");
//     const [endDate, setEndDate] = useState("");
//     const [activeKey, setActiveKey] = useState("0");
//     const [state, setState] = useState([
//         {
//             startDate: new Date(),
//             endDate: new Date(),
//             key: "selection",
//         },
//     ]);

//     const [stats, setStats] = useState(null);
//     const [selectedTime, setSelectedTime] = useState("1 Day");
//     const [showDateFilter, setShowDateFilter] = useState(false);
//     const [dateFilterLabel, setDateFilterLabel] = useState("");

//     const formatDates = (times) => {
//         let date = null;
//         let date1 = null;
//         if (Array.isArray(times)) {
//             let a = new Date(times[0]?.startDate);
//             let b = new Date(times[0]?.endDate);
//             date = moment(a).format("Y-MM-DDT00:00:00");
//             date1 = moment(b).format("Y-MM-DDT23:59:59");
//             setState(times);
//         } else if (times == "1") {
//             var date12 = new Date();
//             var dateOffset = 24 * 60 * 60 * 1000 * 0; //1 day
//             var myDate = new Date();
//             myDate.setTime(myDate.getTime() - dateOffset);
//             date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
//             date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
//         } else if (times == "3") {
//             var date12 = new Date();
//             var dateOffset = 24 * 60 * 60 * 1000 * 3; //3 days
//             var myDate = new Date();
//             myDate.setTime(myDate.getTime() - dateOffset);
//             date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
//             date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
//         } else if (times == "seven") {
//             var date12 = new Date();
//             var dateOffset = 24 * 60 * 60 * 1000 * 7; //7 days
//             var myDate = new Date();
//             myDate.setTime(myDate.getTime() - dateOffset);
//             date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
//             date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
//         } else if (times == "year") {
//             var date12 = new Date();
//             var dateOffset = 24 * 60 * 60 * 1000 * 365; //1 year
//             var myDate = new Date();
//             myDate.setTime(myDate.getTime() - dateOffset);
//             date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
//             date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
//         } else if (times == "month") {
//             var date12 = new Date();
//             var dateOffset = 24 * 60 * 60 * 1000 * 31; //1 month
//             var myDate = new Date();
//             myDate.setTime(myDate.getTime() - dateOffset);
//             date = moment(myDate).utc().format("Y-MM-DDT00:00:00");
//             date1 = moment(date12).utc().format("Y-MM-DDT23:59:59");
//         }
//         setStartDate(date);
//         setEndDate(date1);

//         const startDateObj = date ? new Date(date) : null;
//         const endDateObj = date1 ? new Date(date1) : null;
//         setDateFilterLabel(formatDisplayDates(startDateObj, endDateObj));
//     };

//     const fetchStats = async (start = startDate, end = endDate) => {
//         try {
//             const accessToken = localStorage.getItem('accessToken');
//             let url = `${Api_Url}/credit/stats`;
//             if (start && end) {
//                 url += `?startDate=${start}&endDate=${end}`;
//             }
//             const response = await axios.get(url, {
//                 headers: {
//                     Authorization: `Bearer ${accessToken}`,
//                 },
//             });
//             setStats(response?.data?.data);
//             if (start && end) {
//                 setShowDateFilter(true);
//             }
//         } catch (error) {
//             console.error('Error fetching credit stats:', error);
//         }
//     };

//     const applyFilters = () => {
//         fetchStats();
//         handleClose3();
//     };

//     const clearFilters = () => {
//         setStartDate("");
//         setEndDate("");
//         setSelectedTime("1 Day");
//         setShowDateFilter(false);
//         setState([
//             {
//                 startDate: new Date(),
//                 endDate: new Date(),
//                 key: "selection",
//             },
//         ]);
//         fetchStats("", "");
//     };

//     const handleTimeSelect = (time) => {
//         setSelectedTime(time);
//         formatDates(timeToParam(time));
//     };

//     const removeDateFilter = () => {
//         clearFilters();
//     };

//     const [tableKey, setTableKey] = useState(0);
//     const refreshTable = () => {
//         setTableKey(prevKey => prevKey + 1);
//     };

//     useEffect(() => {
//         formatDates("1");
//         fetchStats();
//     }, []);

//     return {
//         show3,
//         handleClose3,
//         handleShow3,
//         startDate,
//         endDate,
//         activeKey,
//         setActiveKey,
//         state,
//         setState,
//         stats,
//         selectedTime,
//         showDateFilter,
//         dateFilterLabel,
//         formatDates,
//         fetchStats,
//         applyFilters,
//         clearFilters,
//         handleTimeSelect,
//         removeDateFilter,
//         tableKey,
//         refreshTable,
//     };
// };

// export default useCreditDashboardData;